export default "__VITE_ASSET__BMnvislt__"